module.exports = __webpack_public_path__ + "assets/amazonpay.f1d70f8f5de1bad37aee1c8bf99077d5.svg";